module.exports = __webpack_public_path__ + "img/cl-install-hp-connection_12200.bc154dbb.png";